module.exports = __webpack_public_path__ + "10821f845592dbbd3f252b8085154658.png";